﻿'use strict';
import axios from "axios";
import fetch from 'isomorphic-unfetch'
import moment from "moment";

export const detectDeviceType = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ? 'Mobile'
    : 'Desktop';

export const formatImage = (
  image,
  imageFormat = { format: "w_300,c_scale", extension: "f_auto" },
  isFallback = false
) => {

  if (!image && image.templateUrl === null) {
    return;
  }

  if (!image.templateUrl) {
    return;
  }

  return {
    highQuality: image.templateUrl.replace(
      "{formatInstructions}",
      `${imageFormat.format}/${imageFormat.extension}`
    ),
    lowQuality: image.templateUrl.replace(
      "{formatInstructions}",
      `${imageFormat.format}/${
      imageFormat.extension
      }/e_blur:1000,q_1,f_auto/e_grayscale/`
    ),
    title: image.title,
    isFallback
  };
};

export const formatImageUrl = (
  url,
  imageFormat = { format: "w_300,c_scale", extension: "f_auto" },
  isFallback = false
) => {
  if (!url && typeof url !== "string") {
    return;
  }

  return {
    highQuality: url.replace(
      "{formatInstructions}",
      `${imageFormat.format}/${imageFormat.extension}`
    ),
    lowQuality: url.replace(
      "{formatInstructions}",
      `${imageFormat.format}/${
      imageFormat.extension
      }/e_blur:1000,q_1,f_auto/e_grayscale/`
    ),
    title: "",
    isFallback
  };
};

export const addClass = (element, className) => {
  if (element) {
    element.classList.add(className);
  }
}

export const removeClass = (element, className) => {
  if (element) {
    element.classList.remove(className);
  }
}


export function getHeader(list) {
  if (!list || list.length === 0) {
    return;
  }

  let header;

  switch (list[0].key) {
    case "greatest":
      header = "Select the Greatest";
      break;
    case "teams":
      header = "Select a Team";
      break;
    case "celebrities":
      header = "Select a Celebrity Type";
      break;
    default:
      header = "Where do you live?";
  }

  return header;
};


export const getLayerImage = (layer, imageFormat) => {
  if (layer && layer.image && layer.image.templateUrl) {
    const image = layer.image;
    return formatImage(image, imageFormat);
  }

  const fallbackImage = {
    title: "default",
    templateUrl:
      "https://res.cloudinary.com/deltatrenfl100/image/private/{formatInstructions}/f_png/nfl100-dev/u16xjbo7nh6m9w9hmjkt"
  }

  return formatImage(fallbackImage, imageFormat, true);
};

export const removeFadeOut = (element, speed) => {
  const seconds = 0.5;
  element.style.transition = 'opacity ' + seconds + 's ease';
  element.style.opacity = 0;
  setTimeout(() => element.parentNode.removeChild(element), speed);
};

export const getTheme = () => {
  const themeName = document.querySelector('[class*="theme"]').classList[1];
  if (!themeName && themeName.includes('theme')) {
    return;
  }

  switch (themeName) {
    case "theme--experiences":
      return "EXPERIENCES OF A LIFETIME";
    case "theme--huddle":
      return "HUDDLE FOR 100";
    case "theme--original-towns":
      return "ORIGINAL TOWNS";
    case "theme--originals":
      return "NFL 100 ORIGINALS";
    case "theme--moment":
      return "NFL 100 GREATEST";
    case "theme--all-time-team":
      return "NFL ALL TIME TEAM";
    case "theme--greatest-moment":
      return "GREATEST MOMENT";
    case "theme--greatest-photos-100":
      return "100 GREATEST PHOTOS"
    default:
      return "NFL 100";
  }
};

export function multiFilter(array, filters) {
  const filterKeys = Object.keys(filters);
  // filters all elements passing the criteria
  return array.filter(item => {
    // dynamically validate all filter criteria
    return filterKeys.every(key => {
      // ignores an empty filter
      if (!filters[key].length) return true;

      if (item.tags[key]) {
        return item.tags[key].some(tag => {
          return tag.includes(filters[key])
        })
      }

    });
  });
}

export const normalizeMoments = items => {
  const moments = items && items.map(item => {
    return {
      ...item,
      tags: item.tags.reduce((tagsObject, tag) => {
        const category = tag.fields.category;

        if (!category) {
          return tagsObject;
        }
        if (!tagsObject[category]) {
          // if category exists"
          tagsObject[category] = [tag.title.toUpperCase()];
        }
        else {
          tagsObject[category] = [...tagsObject[category], tag.title.toUpperCase()]
        }
        return tagsObject;
      }, {}),
    };
  });

  return moments;
};

export const getName = ({ firstName, lastName, displayName }) => {
  if (!firstName && !lastName && !displayName) {
    return null
  }

  if (!firstName) {
    return displayName
  }
  else if (lastName) {
    return `${firstName} ${lastName}`
  }
  else {
    return firstName
  }
}

export const getLastWordOfString = title => {
  if (!title) {
    return "";
  }
  return title.substring(title.lastIndexOf(" ") + 1);
}

export const formatPersonEntity = items => {
  const persons = items.map((item, index) => {
    const { fields, thumbnail } = item;

    if (fields) {
      return {
        title: `${fields.firstName || ''} ${fields.lastName || ''}` || fields.displayName,
        id: ++index,
        selected: false,
        key: "celebrities",
        personType: fields.personType || '',
        thumbnail,
      };
    }
  });

  return persons;
};

export const getForgeData = dataPath => {
  return axios
    .get(dataPath)
    .then(res => {
      let { pagination, items } = res.data;

      if (pagination && pagination.nextUrl) {
        return getForgeData(pagination.nextUrl).then(nextItems => {
          return items.concat(nextItems);
        });
      } else {

        return items;
      }
    })
};

export const isQuotaExceeded = e => {
  var quotaExceeded = false;
  if (e) {
    if (e.code) {
      switch (e.code) {
        case 22:
          quotaExceeded = true;
          break;
        case 1014:
          // Firefox
          if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
            quotaExceeded = true;
          }
          break;
      }
    } else if (e.number === -2147024882) {
      // Internet Explorer 8
      quotaExceeded = true;
    }
  }
  return quotaExceeded;
}

export const resizeElement = (element, type) => {
  if (!element) {
    return;
  }

  const figureWidth = element.offsetWidth;

  if (figureWidth && figureWidth > 0) {
    element.style.height = `${figureWidth}px`;
  }
}

export const variants = {
  slideUp: {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 }
  },
  numberVariant: {
    onHoverStart: { scale: 1.1 },
    onHoverEnd: { scale: 1 },
  },
  secondLayerVariant: {
    onHoverStart: { x: 30, y: -20, scale: 1.1 },
    onHoverEnd: { x: 0, y: 0, scale: 1 },
  },
  thirdLayerVariant: {
    onHoverStart: { y: -10, scale: 1.02 },
    onHoverEnd: { y: 0, scale: 1 },
  },
  modal: {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1
    }
  }
};

export const positionList = [
  { positionShort: "RB", positionLong: "Running Back" },
  { positionShort: "LB", positionLong: "Linebacker" },
  { positionShort: "DE", positionLong: "Defensive End" },
  {
    positionShort: "DT",
    positionLong: "Defensive Tackle"
  },
  { positionShort: "CB", positionLong: "Cornerback" },
  { positionShort: "S", positionLong: "Safety" },
  { positionShort: "K", positionLong: "Kicker" },
  { positionShort: "PS", positionLong: "Punter" },
  { positionShort: "RS", positionLong: "Returner" },
  { positionShort: "TE", positionLong: "Tight End" },
  {
    positionShort: "OT",
    positionLong: "Offensive Tackle"
  },
  { positionShort: "G", positionLong: "Guard" },
  { positionShort: "C", positionLong: "Center" },
  { positionShort: "WR", positionLong: "Wide Receiver" },
  { positionShort: "QB", positionLong: "Quarterback" },
  { positionShort: "CO", positionLong: "Coach" }
];


export const getInitialTeams = (hasAllTeams = true) => {
  const teams = [
    { title: "All Teams", id: 32, key: "teams", selected: true },
    {
      title: "Arizona Cardinals",
      id: 0,
      key: "teams",
      selected: false,
      shortName: "ARI",
    },
    {
      title: "Atlanta Falcons",
      id: 1,
      key: "teams",
      selected: false,
      shortName: "ATL"
    },
    {
      title: "Baltimore Ravens",
      id: 2,
      key: "teams",
      selected: false,
      shortName: "BAL"
    },
    {
      title: "Buffalo Bills",
      id: 3,
      key: "teams",
      selected: false,
      shortName: "BUF"
    },
    {
      title: "Carolina Panthers",
      id: 4,
      key: "teams",
      selected: false,
      shortName: "CAR"
    },
    {
      title: "Chicago Bears",
      id: 5,
      key: "teams",
      selected: false,
      shortName: "CHI"
    },
    {
      title: "Cincinnati Bengals",
      id: 6,
      key: "teams",
      selected: false,
      shortName: "CIN"
    },
    {
      title: "Cleveland Browns",
      id: 7,
      key: "teams",
      selected: false,
      shortName: "CLE"
    },
    {
      title: "Dallas Cowboys",
      id: 8,
      key: "teams",
      selected: false,
      shortName: "DAL"
    },
    {
      title: "Denver Broncos",
      id: 9,
      key: "teams",
      selected: false,
      shortName: "DEN"
    },
    {
      title: "Detroit Lions",
      id: 10,
      key: "teams",
      selected: false,
      shortName: "DET"
    },
    {
      title: "Green Bay Packers",
      id: 11,
      key: "teams",
      selected: false,
      shortName: "GB"
    },
    {
      title: "Houston Texans",
      id: 12,
      key: "teams",
      selected: false,
      shortName: "HOU"
    },
    {
      title: "Indianapolis Colts",
      id: 13,
      key: "teams",
      selected: false,
      shortName: "IND"
    },
    {
      title: "Jacksonville Jaguars",
      id: 14,
      key: "teams",
      selected: false,
      shortName: "JAX"
    },
    {
      title: "Kansas City Chiefs",
      id: 15,
      key: "teams",
      selected: false,
      shortName: "KC"
    },
    {
      title: "Los Angeles Rams",
      id: 16,
      key: "teams",
      selected: false,
      shortName: "LAR"
    },
    {
      title: "Los Angeles Chargers",
      id: 17,
      key: "teams",
      selected: false,
      shortName: "LAC"
    },
    {
      title: "Miami Dolphins",
      id: 18,
      key: "teams",
      selected: false,
      shortName: "MIA"
    },
    {
      title: "Minnesota Vikings",
      id: 19,
      key: "teams",
      selected: false,
      shortName: "MIN"
    },
    {
      title: "New England Patriots",
      id: 20,
      key: "teams",
      selected: false,
      shortName: "NE"
    },
    {
      title: "New Orleans Saints",
      id: 21,
      key: "teams",
      selected: false,
      shortName: "NO"
    },
    {
      title: "New York Giants",
      id: 22,
      key: "teams",
      selected: false,
      shortName: "NYG"
    },
    {
      title: "New York Jets",
      id: 23,
      key: "teams",
      selected: false,
      shortName: "NYJ"
    },
    {
      title: "Oakland Raiders",
      id: 24,
      key: "teams",
      selected: false,
      shortName: "OAK"
    },
    {
      title: "Philadelphia Eagles",
      id: 25,
      key: "teams",
      selected: false,
      shortName: "PHI"
    },
    {
      title: "Pittsburgh Steelers",
      id: 26,
      key: "teams",
      selected: false,
      shortName: "PIT"
    },
    {
      title: "San Francisco 49ers",
      id: 27,
      key: "teams",
      selected: false,
      shortName: "SF"
    },
    {
      title: "Seattle Seahawks",
      id: 28,
      key: "teams",
      selected: false,
      shortName: "SEA"
    },
    {
      title: "Tampa Bay Buccaneers",
      id: 29,
      key: "teams",
      selected: false,
      shortName: "TB"
    },
    {
      title: "Tennessee Titans",
      id: 30,
      key: "teams",
      selected: false,
      shortName: "TEN"
    },
    {
      title: "Washington Redskins",
      id: 31,
      key: "teams",
      selected: false,
      shortName: "WAS"
    }
  ];

  return hasAllTeams ? teams : teams.filter(team => team.id !== 32);
};



export const fetchData = (url, config) => {
  return fetch(url, config)
    .then(res => {
      return res.json();
    })
    .then(data => {
      return { data, error: null };
    })
    .catch(error => {
      return {
        data: null,
        error
      };
    });
};

export const usStates = [
  {
    id: 0,
    key: "location",
    selected: false,
    title: "Alabama",
    val: "01"
  },
  {
    id: 1,
    key: "location",
    selected: false,
    title: "Alaska",
    val: "02"
  },
  {
    id: 2,
    key: "location",
    selected: false,
    title: "Arizona",
    val: "04"
  },
  {
    id: 3,
    key: "location",
    selected: false,
    title: "Arkansas",
    val: "05"
  },
  {
    id: 4,
    key: "location",
    selected: false,
    title: "California",
    val: "06"
  },
  {
    id: 5,
    key: "location",
    selected: false,
    title: "Colorado",
    val: "08"
  },
  {
    id: 6,
    key: "location",
    selected: false,
    title: "Connecticut",
    val: "09"
  },
  {
    id: 7,
    key: "location",
    selected: false,
    title: "Delaware",
    val: "10"
  },
  {
    id: 8,
    key: "location",
    selected: false,
    title: "Florida",
    val: "12"
  },
  {
    id: 9,
    key: "location",
    selected: false,
    title: "Georgia",
    val: "13"
  },
  {
    id: 10,
    key: "location",
    selected: false,
    title: "Hawaii",
    val: "15"
  },
  {
    id: 11,
    key: "location",
    selected: false,
    title: "Idaho",
    val: "16"
  },
  {
    id: 12,
    key: "location",
    selected: false,
    title: "Illinois",
    val: "17"
  },
  {
    id: 13,
    key: "location",
    selected: false,
    title: "Indiana",
    val: "18"
  },
  {
    id: 14,
    key: "location",
    selected: false,
    title: "Iowa",
    val: "19"
  },
  {
    id: 15,
    key: "location",
    selected: false,
    title: "Kansas",
    val: "20"
  },
  {
    id: 16,
    key: "location",
    selected: false,
    title: "Kentucky",
    val: "21"
  },
  {
    id: 17,
    key: "location",
    selected: false,
    title: "Louisiana",
    val: "22"
  },
  {
    id: 18,
    key: "location",
    selected: false,
    title: "Maine",
    val: "23"
  },
  {
    id: 19,
    key: "location",
    selected: false,
    title: "Maryland",
    val: "24"
  },
  {
    id: 20,
    key: "location",
    selected: false,
    title: "Massachusetts",
    val: "25"
  },
  {
    id: 21,
    key: "location",
    selected: false,
    title: "Michigan",
    val: "26"
  },
  {
    id: 22,
    key: "location",
    selected: false,
    title: "Minnesota",
    val: "27"
  },
  {
    id: 23,
    key: "location",
    selected: false,
    title: "Mississippi",
    val: "28"
  },
  {
    id: 24,
    key: "location",
    selected: false,
    title: "Missouri",
    val: "29"
  },
  {
    id: 25,
    key: "location",
    selected: false,
    title: "Montana",
    val: "30"
  },
  {
    id: 26,
    key: "location",
    selected: false,
    title: "Nebraska",
    val: "31"
  },
  {
    id: 27,
    key: "location",
    selected: false,
    title: "Nevada",
    val: "32"
  },
  {
    id: 28,
    key: "location",
    selected: false,
    title: "New Hampshire",
    val: "33"
  },
  {
    id: 29,
    key: "location",
    selected: false,
    title: "New Jersey",
    val: "34"
  },
  {
    id: 30,
    key: "location",
    selected: false,
    title: "New Mexico",
    val: "35"
  },
  {
    id: 31,
    key: "location",
    selected: false,
    title: "New York",
    val: "36"
  },
  {
    id: 32,
    key: "location",
    selected: false,
    title: "North Carolina",
    val: "37"
  },
  {
    id: 33,
    key: "location",
    selected: false,
    title: "North Dakota",
    val: "38"
  },
  {
    id: 34,
    key: "location",
    selected: false,
    title: "Ohio",
    val: "39"
  },
  {
    id: 35,
    key: "location",
    selected: false,
    title: "Oklahoma",
    val: "40"
  },
  {
    id: 36,
    key: "location",
    selected: false,
    title: "Oregon",
    val: "41"
  },
  {
    id: 37,
    key: "location",
    selected: false,
    title: "Pennsylvania",
    val: "42"
  },
  {
    id: 38,
    key: "location",
    selected: false,
    title: "Rhode Island",
    val: "44"
  },
  {
    id: 39,
    key: "location",
    selected: false,
    title: "South Carolina",
    val: "45"
  },
  {
    id: 40,
    key: "location",
    selected: false,
    title: "South Dakota",
    val: "46"
  },
  {
    id: 41,
    key: "location",
    selected: false,
    title: "Tennessee",
    val: "47"
  },
  {
    id: 42,
    key: "location",
    selected: false,
    title: "Texas",
    val: "48"
  },
  {
    id: 43,
    key: "location",
    selected: false,
    title: "Utah",
    val: "49"
  },
  {
    id: 44,
    key: "location",
    selected: false,
    title: "Vermont",
    val: "50"
  },
  {
    id: 45,
    key: "location",
    selected: false,
    title: "Virginia",
    val: "51"
  },
  {
    id: 46,
    key: "location",
    selected: false,
    title: "Washington",
    val: "53"
  },
  {
    id: 47,
    key: "location",
    selected: false,
    title: "West Virginia",
    val: "54"
  },
  {
    id: 48,
    key: "location",
    selected: false,
    title: "Wisconsin",
    val: "55"
  },
  {
    id: 49,
    key: "location",
    selected: false,
    title: "Wyoming",
    val: "56"
  },
  {
    id: 50,
    key: "location",
    selected: false,
    title: "Other",
    val: "57"
  }
];

export const initialCelebrities = [
    { title: "ALL CELEBRITIES", id: 0, key: "celebrities", selected: true },
    { title: "ACTOR", id: 1, key: "celebrities", selected: false },
    { title: "MUSICIAN", id: 2, key: "celebrities", selected: false },
    { title: "CELEBRITY", id: 3, key: "celebrities", selected: false },
    { title: "ATHLETE", id: 4, key: "celebrities", selected: false },
    { title: "REPORTER", id: 5, key: "celebrities", selected: false },
    { title: "INFLUENCER", id: 6, key: "celebrities", selected: false },
  ];

export const initialGreatest = ({ games, teams, characters, plays, gameChangers }) => {
  return [
    {
      id: 0,
      title: "GREATEST GAMES",
      selected: false,
      key: "greatest",
      dataPath: games,
    },
    {
      id: 1,
      title: "GREATEST TEAMS",
      selected: false,
      key: "greatest",
      dataPath: teams,
    },
    {
      id: 2,
      title: "GREATEST CHARACTERS",
      selected: false,
      key: "greatest",
      dataPath: characters,
    },
    {
      id: 3,
      title: "GREATEST PLAYS",
      selected: false,
      key: "greatest",
      dataPath: plays,
    },
    {
      id: 4,
      title: "GREATEST GAME-CHANGERS",
      selected: false,
      key: "greatest",
      dataPath: gameChangers,
    },
  ]
}

export function createAvailablePositionList({
  runningbacks,
  linebackers,
  defensiveends,
  defensivetackles,
  cornerbacks,
  safeties,
  kickers,
  punters,
  returners,
  tightends,
  offensivetackles,
  guards,
  centers,
  widereceivers,
  quarterbacks,
  coaches
}) {

  const defaultConfig = {
    predictionAvailable: {
      predictionEndText: null,
      predictionStartText: null,
      isBeforePrediction: true,
      predictionIsLive: false
    },
  }

  return [
    {
      positionShort: "RB",
      positionLong: "Running Back",
      url: runningbacks || null,
      ...defaultConfig
    },
    {
      positionShort: "LB",
      positionLong: "Linebacker",
      url: linebackers || null,
      ...defaultConfig
    },
    {
      positionShort: "DE",
      positionLong: "Defensive End",
      url: defensiveends || null,
      ...defaultConfig
    },
    {
      positionShort: "DT",
      positionLong: "Defensive Tackle",
      url: defensivetackles || null,
      ...defaultConfig
    },
    {
      positionShort: "CB",
      positionLong: "Cornerback",
      url: cornerbacks || null,
      ...defaultConfig
    },
    {
      positionShort: "S",
      positionLong: "Safety",
      url: safeties || null,
      ...defaultConfig
    },
    {
      positionShort: "K",
      positionLong: "Kicker",
      url: kickers || null,
      ...defaultConfig
    },
    {
      positionShort: "PS",
      positionLong: "Punter",
      url: punters || null,
      ...defaultConfig
    },
    {
      positionShort: "RS",
      positionLong: "Returner",
      url: returners || null,
      ...defaultConfig
    },
    {
      positionShort: "TE",
      positionLong: "Tight End",
      url: tightends || null,
      ...defaultConfig
    },
    {
      positionShort: "OT",
      positionLong: "Offensive Tackle",
      url: offensivetackles || null,
      ...defaultConfig
    },
    {
      positionShort: "G",
      positionLong: "Guard",
      url: guards || null,
      ...defaultConfig
    },
    {
      positionShort: "C",
      positionLong: "Center",
      url: centers || null,
      ...defaultConfig
    },
    {
      positionShort: "WR",
      positionLong: "Wide Receiver",
      url: widereceivers || null,
      ...defaultConfig
    },
    {
      positionShort: "QB",
      positionLong: "Quarterback",
      url: quarterbacks || null,
      ...defaultConfig
    },
    {
      positionShort: "CO",
      positionLong: "Coach",
      url: coaches || null,
      ...defaultConfig
    }
  ];
}

export function checkPredictionAvailability({ startTime, endTime }) {
  if (!startTime || !endTime) {
    return false;
  }

  const now = moment.utc(Date.now());
  const isBefore = now.isBefore(startTime);

  const startDay = moment.utc(startTime).format("dddd, MMMM Do");
  const endDay = moment.utc(endTime).format("dddd, MMMM Do");

  return {
    predictionStartText: `Predictions will be open on ${startDay}`,
    predictionEndText: `${endDay}`,
    isBeforePrediction: isBefore,
    predictionIsLive: now.isBetween(startTime, endTime)
  };
}

export const getImageFormat = (
  format = "w_250,h_250",
  extension = "f_auto"
) => {
  return {
    thumbnail: {
      format: "w_250,h_250,c_fill",
      extension
    },
    thumbnailFace: {
      format: "g_face,c_thumb,w_100,h_100,z_0.7",
      extension
    },
    portrait: {
      format: "t_portrait_mobile",
      extension
    },
    square: {
      format: "t_editorial_squared_6_desktop",
      extension
    },
    landscape: {
      format: "t_editorial_landscape_12_desktop",
      extension
    },
    custom: {
      format,
      extension
    }
  };
};

export function chunk(array, size) {
  const chunked_arr = [];
  for (let i = 0; i < array.length; i++) {
    const last = chunked_arr[chunked_arr.length - 1];
    if (!last || last.length === size) {
      chunked_arr.push([array[i]]);
    } else {
      last.push(array[i]);
    }
  }
  return chunked_arr;
}

export function getVideoData(customEntityObj) {
  const { fields } = customEntityObj || {}
  return {
    path,
    secure_url,
    public_id,
    thumnail_url,
    url,
  } = fields || {}
}

export function getPublicId(templateUrl, cloudName) {
  if (templateUrl !== null) {
    const regexp = cloudName === "nflclubs" ? "https://static.clubs.nfl.com/image/private/{formatInstructions}/" : "https://res.cloudinary.com/deltatrenfl100/image/private/{formatInstructions}/";
    return templateUrl.replace(regexp, "");
  }
  return "";
}

export function getEnvironment(location) {
  if (!location) {
    return;
  }

  return location.includes('www.nfl.com') ?
    {
      env: 'prd',
      feUrl: "https://www.nfl.com/100",
      dapi: "https://prd-nfl100-forge-dapi.deltatre.net",
      cloudName: 'nflclubs'
    }
    :
    {
      env: 'dev',
      feUrl: "https://nfl100-dev-fe-en.azurewebsites.net/100",
      dapi: "https://nfl100-dev-forge-dapi.azurewebsites.net",
      cloudName: 'deltatrenfl100',
    }
}

export function isoFetch(...args) {
  return fetch(...args).then(res => res.json())
}

export function fetchItems(...args) {
  return axios.get(...args)
    .then(res => res.data)
    .then(res => {
      return res.Items
        ? camelcase(res.Items, { deep: true }) : res.items
    })
    .catch(error => console.log("There was a problem when fetching the Item data: ", error));
}

export function fetchMoments(...args) {
  return axios.get(...args)
    .then(res => res.data)
    .then(res => {
      return camelcase(res, { deep: true })
    })
    .catch(error => console.log("There was a problem when fetching the Item data: ", error));
}

export function fetchGreatestMoment(...args) {
  return axios.get(...args)
    .then(res => res.data)
    .then(res => {
      const { fields, selfUrl, _entityId, _translationId, thumbnail, references, slug } = res || {}
      return {
        fields,
        _translationId,
        selfUrl,
        slug,
        _entityId,
        thumbnail,
        references
      }
    })
    .catch(error => console.log("There was a problem when fetching the Moment data: ", error));
}

export function fetchGreatestMomentGroup(...args) {
  return axios.get(...args)
    .then(res => res.data)
    .then(res => {
      const { items } = res || {}
      return items.map(item => {
        const { fields, selfUrl, _entityId, _translationId, thumbnail, references, slug } = item || {}
        return {
          fields,
          _translationId,
          selfUrl,
          slug,
          _entityId,
          thumbnail,
          references,
          isSelected: false
        }
      })
    })
    .catch(error => console.log("There was a problem when fetching the Item data: ", error));
}

export function fetchTeams(...args) {
  return axios.get(...args)
    .then(res => res.data)
    .then(res => {
      const teams = camelcase(res.Teams, { deep: true });
      return teams;
    }).catch(error => console.log("There was a problem when fetching the Teams data: ", error));
}

export function fetchDashboardSelection(...args) {
  return axios(...args)
    .then(res => res.data)
    .then(res => {
      const { items } = res || {};

      return items.map(item => {
        const { fields, slug, title, selfUrl, featured } = item

        return {
          slug,
          positionShort: fields.positionType || "",
          positionLong: item.title || "",
          selfUrl,
          isSelected: featured === 1
        }
      })

    }).catch(error => console.error('There was a problem when fetching the Dashboard data', error))
}

export function fetchAverages(...args) {
  return axios.get(...args)
    .then(res => res.data)
    .then(res => {
      const { average, positions } = camelcase(res, { deep: true }) || {};

      return {
        average,
        positions
      };
    }).catch(error => console.log("There was a problem when fetching the Average data: ", error))
}

export function fetchPosition(...args) {
  return axios.get(...args)
    .then(res => res.data)
    .then(res => {
      const { fields, references } = res || {};

      return {
        players: references.players || [],
        position: fields.positionType || null,
        maxCount: fields.maxCount || null,
        predictionState: fields.predictionState || null,
      };
    }).catch(error => console.log("There was a problem when fetching the Position data: ", error));
}

export function fetchImages(...args) {
  return axios.get(...args)
    .then(res => res.data)
    .then(res => res.items)
    .then(res => {
      return res.map(item => {
        return item.image;
      });
    }).catch(error => console.log("There was a problem when fetching the Image data: ", error));
}

export function fetchPlayerData(...args) {
  return axios.get(...args)
    .then(res => res.data)
    .then(res => {
      const { references, fields, thumbnail } = res || {}
      const { highlightVideo } = references || {}

      return { highlightVideo: highlightVideo && highlightVideo[0], fields, thumbnail }
    }).catch(error => console.log("There was a problem when fetching the Player data: ", error));
}

export function fetchPlayers(...args) {
  return axios.get(...args)
    .then(res => res.data)
    .then(res => {
      const { items } = res
      return items && items.length > 0 ? items.map(player => {
        const { references, fields, thumbnail } = player || {}
        const { highlightVideo } = references || {}

        return { highlightVideo: highlightVideo && highlightVideo[0], fields, thumbnail }
      }) : null;
    }).catch(error => console.log("There was a problem when fetching the Player data: ", error));
}

export function formatDataForDB(selectedItems, dataCapture, currentPosition) {
  const sanitizedPlayers = selectedItems && selectedItems.length > 0 && selectedItems.map(item => {
    return sanitizePlayerForDB(item)
  })

  const { location, teams } = dataCapture;
  const { positionShort, positionLong } = currentPosition

  return {
    location, teamName: teams, players: sanitizedPlayers, positionShort, positionLong
  }
}

export function formatGreatestMomentDataForDB(selectedItems) {
  const sanitizedMoments = selectedItems && selectedItems.length > 0 && selectedItems.map(item => {
    return sanitizeMomentForDB(item)
  })

  return {
    selection: sanitizedMoments
  }
}

export function sanitizeMomentForDB(item) {
  const {
    fields,
    _entityId,
    _translationId,
    references,
    slug,
    selfUrl } = item

  const videoData = (references && references.firstLayer && references.firstLayer[0] && references.firstLayer[0].fields && references.firstLayer[0].fields.videoData) || null

  return {
    entityId: _entityId,
    translationId: _translationId,
    selfUrl,
    fields,
    videoData,
    slug,
  }
}

export function sanitizePlayerForDB(item) {
  const {
    fields,
    type,
    featured,
    _entityId,
    _translationId,
    createdBy,
    lastUpdatedBy,
    contentDate,
    tags,
    entityCode,
    lastUpdatedDate,
    selfUrl, ...otherProps } = item

  const {
    careerLength,
    displayName,
    firstName,
    lastName,
    yearsActive,
    assignedDivision,
    preferredTeam
  } = fields || {};

  const newItem = {
    entityId: _entityId,
    selfUrl,
    firstName,
    lastName,
    careerLength,
    displayName,
    preferredTeam,
    yearsActive,
    division: assignedDivision,
    ...otherProps
  }

  return newItem;
}

export const formatPositionDataAsync = item => {
  return fetchData(item.url).then(res => {
    const { data, error } = res;

    if (!error) {
      const { fields, thumbnail, references } = data || {};
      const { players } = references || [];

      const { startTime, endTime, maxCount, allTimeTeamSelection, description, predictionState } =
        fields || {};

      const predictionAvailable = checkPredictionAvailability({
        startTime,
        endTime
      });

      const updatedItem = {
        ...item,
        predictionAvailable,
        description,
        predictionState,
        maxCount: maxCount || 4,
        players,
        thumbnail
      };

      return updatedItem;
    }

    return item;
  });
};


export function isSafariMobile() {
  if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
    return false;
  }

  const {
    navigator: { userAgent },
  } = window;
  return (
    /iP(ad|od|hone)/i.test(userAgent) &&
    /WebKit/i.test(userAgent) &&
    !/(CriOS|FxiOS|OPiOS|mercury)/i.test(userAgent)
  );
}

let convert = (input, removeDigitFromStart) => {
  if ((removeDigitFromStart && new RegExp(/[aA-zZ]/).test(input)) || new RegExp(/[aA-zZ]/).test(input)) {
    return input.replace(/^[0-9]/, '').replace(/^[_.\- ]+/, '').toLowerCase().replace(/[_.(|)\- ]+(\w|$)/g, (m, p1) => p1.toUpperCase())
  } else {
    return input
  }
}

let processObject = (input, options, out) => {
  // let out
  switch (typeof input) {
    case 'object':
      for (let key in input) {
        out = !out ? {} : out
        if (options.deep) {
          out[camelcase(key, options)] = (typeof input[key] === 'object' && input[key] !== null && input[key] !== undefined) ? camelcase(input[key], options, out[camelcase(key, options)]) : input[key]
        } else {
          out[camelcase(key, options, out)] = input[key]
        }
      }
      break
    default:
      out = convert(input.trim())
      break
  }
  return out
}

let processArray = (input, options, out) => {
  return Object.keys(input).map(key => { return processObject(input[key], options, (out && out[key] ? out[key] : null)) })
}

let preserveCamelCase = (input) => {
  let isLastCharLower = false
  let isLastCharUpper = false
  let isLastLastCharUpper = false

  for (let i = 0; i < input.length; i++) {
    const c = input[i]

    if (isLastCharLower && /[a-zA-Z]/.test(c) && c.toUpperCase() === c) {
      input = input.slice(0, i) + '-' + input.slice(i)
      isLastCharLower = false
      isLastLastCharUpper = isLastCharUpper
      isLastCharUpper = true
      i++
    } else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(c) && c.toLowerCase() === c) {
      input = input.slice(0, i - 1) + '-' + input.slice(i - 1)
      isLastLastCharUpper = isLastCharUpper
      isLastCharUpper = false
      isLastCharLower = true
    } else {
      isLastCharLower = c.toLowerCase() === c
      isLastLastCharUpper = isLastCharUpper
      isLastCharUpper = c.toUpperCase() === c
    }
  }

  return input
}

export let camelcase = (input, options, out) => {
  if (!input) {
    throw new Error('Invalid input provided.')
  }

  options = Object.assign({
    deep: false,
    removeDigitFromStart: false
  }, options)

  let output

  switch (typeof input) {
    case 'string':
      const hasUpperCase = input !== input.toLowerCase()
      if (hasUpperCase) {
        input = preserveCamelCase(input)
      }
      output = convert(input.trim(), options.removeDigitFromStart)
      break
    case 'object':
      if (Array.isArray(input)) {
        output = processArray(input, options, out)
      } else {
        output = processObject(input, options, out)
      }
  }
  return output
}

export function getNewPath(currentUrl, newDir) {
  if (!currentUrl || typeof currentUrl !== "string" || !newDir || typeof newDir !== "string") {
    return ""
  }

  const lastDir = currentUrl.match(/([^\/]*)\/*$/)[1]
  return lastDir.includes('all') || lastDir.includes('greatest')
    ? `${currentUrl}${newDir}`
    : currentUrl.replace(lastDir, newDir)
  

}

export const appendPlayButton = button => {
  if (!button) {
    return;
  }
  const playSVG = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  playSVG.setAttribute('id', 'Layer_4');
  playSVG.setAttribute('class', 'd3-o-button__video');
  playSVG.setAttribute('data-name', 'Layer 4');
  playSVG.setAttribute('viewBox', '0 0 24 24');
  playSVG.setAttribute('aria-hidden', "true");

  const pathOne = document.createElementNS("http://www.w3.org/2000/svg", "path");
  pathOne.setAttribute("d", "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm-2 15V8l6 4z");
  pathOne.setAttribute("opacity", "0.4");
  playSVG.appendChild(pathOne);

  const pathTwo = document.createElementNS("http://www.w3.org/2000/svg", "path");
  pathTwo.setAttribute("fill", "#FFF");
  pathTwo.setAttribute("d", "M10 16l6-4-6-4v8z");

  playSVG.appendChild(pathTwo);

  const pathThree = document.createElementNS("http://www.w3.org/2000/svg", "path")
  pathThree.setAttribute('d', "M0 0h24v24H0z");
  pathThree.setAttribute('fill', 'none');

  playSVG.appendChild(pathThree)

  const pathFour = document.createElementNS("http://www.w3.org/2000/svg", "path")
  pathFour.setAttribute('d', "M12 2A10 10 0 1 1 2 12 10 10 0 0 1 12 2m0-1a11 11 0 1 0 11 11A11 11 0 0 0 12 1z")
  pathFour.setAttribute('fill', '#FFF');

  playSVG.appendChild(pathFour)

  button.appendChild(playSVG);
}

export const makeButtonVisible = button => {
  if (!button) {
    return;
  }

  setTimeout(() => {
    button.style.zIndex = 1;
  }, 1000);
};

const listeners = []
export const MEDIA_CHANGED = '@@rdx-mqt/MEDIA_CHANGED'

// Reducer
export function reducer(state = {}, action) {
  switch (action.type) {
    case MEDIA_CHANGED:
      return Object.assign({}, state, action.data)
    default:
      return state
  }
}

// Actions
export function mediaChanged(data) {
  return {
    type: MEDIA_CHANGED,
    data,
  }
}

// Cleanup
const unlisteners = []
export function unlisten() {
  unlisteners.forEach(fn => {
    fn()
  })
}

// Handlers
let trackInnerWidth = false
let trackInnerHeight = false
const getSizes = data => {
  if (trackInnerWidth) {
    data.innerWidth = global.innerWidth
  }
  if (trackInnerHeight) {
    data.innerHeight = global.innerHeight
  }
}
let onResize
const makeOnResize = dispatch => () => {
  const data = {}
  getSizes(data)
  dispatch(mediaChanged(data))
}

function trackMediaQuery(label, query, dispatch, initData) {
  // special queries
  if (label === 'innerWidth' || label === 'innerHeight') {
    if (label === 'innerWidth') {
      trackInnerWidth = true
    }
    if (label === 'innerHeight') {
      trackInnerHeight = true
    }
    if (!onResize) {
      onResize = makeOnResize(dispatch)
      if (global.addEventListener) {
        global.addEventListener('resize', onResize, true)
        unlisteners.push(() =>
          global.removeEventListener('resize', onResize, true)
        )
      }
    }
    getSizes(initData)
  }

  const mq = global.matchMedia(query)

  const listener = () =>
    dispatch(
      mediaChanged({
        [label]: mq.matches,
      })
    )
  mq.addListener(listener)
  unlisteners.push(() => mq.removeListener(listener))

  initData[label] = mq.matches
  return
}

function mQTrack(queries, dispatch) {
  const initData = {}
  if (global.matchMedia) {
    for (const label in queries) {
      trackMediaQuery(label, queries[label], dispatch, initData)
    }
    dispatch(mediaChanged(initData))
  }
  return unlisten
}

export function mediaQueryTracker(queries, dispatch) {
  // Allow using as a redux-thunking action or directly
  return dispatch
    ? mQTrack(queries, dispatch)
    : dispatch => mQTrack(queries, dispatch)
}

export const calcVotePercentage = ({ votes, totalVotes, maxCount }) => {
  return votes && totalVotes && maxCount ? `${Math.round(votes / (totalVotes / maxCount) * 100)}%` : "0%";
}